<template>
  <b-container data-app fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title title-typography-color">
              <i class="far fa-comments"></i>
              {{ $t("public.views.Pages.Patient.Session.sessions") }}
            </h4>
          </template>
          <template v-slot:body>
            <div class="text-right"></div>
            <div>
              <v-data-table :footer-props="{
                showFirstLastPage: true,
                firstIcon: 'fas fa-arrow-left',
                lastIcon: 'fas fa-arrow-right',
                prevIcon: 'fas fa-minus',
                nextIcon: 'fas fa-plus',
                'items-per-page-options': [10, 25, 50],
              }" :headers="headers" :items="sessions" :options.sync="pagination" :server-items-length="total"
                item-key="name">
                <template v-slot:item.date="{ item }">
                  {{ new Date(item.startedAt).toLocaleString() }}
                </template>
                <template v-slot:item.modality="{ item }">
                  <span v-if="item.eventPlace === 'ONLINE'" class="badge badge-success">{{
                    $t("generic.online")
                  }}</span>
                  <span v-else class="badge badge-danger">{{
                    $t("generic.offline")
                  }}</span>
                </template>
                <template v-slot:item.hasInvoice="{ item }">
                  <span v-for="(billing, index) in item.billings" v-bind:key="index">
                    <b-badge v-if="billing.invoices && billing.invoices.length !== 0" class="mr-2" variant="success">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                    <b-badge v-else class="mr-2" variant="danger">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                  </span>
                </template>
                <template v-slot:item.hasProfessionalLead="{ item }">
                  <span class="badge badge-primary">{{ item.professionalLead.name }}
                    {{ item.professionalLead.lastname }}</span>
                </template>
                <template v-slot:item.hasProfessionals="{ item }">
                  <span v-for="(professional, index) in item.professionals" v-bind:key="index"
                    class="badge badge-primary mr-2">{{ professional.name }} {{ professional.lastname }}</span>
                </template>
                <template v-slot:item.hasPatients="{ item }">
                  <span v-for="(patient, index) in item.patients" v-bind:key="index" class="badge badge-primary mr-2">{{
                    patient.name
                  }} {{ patient.lastname }} (
                    {{ patient.document }} )</span>
                </template>
                <template v-slot:item.visitType="{ item }">
                  <i :style="'color: ' + item.visitType.colour" class="fas fa-circle mr-2"></i>
                  {{ item.visitType.name }}
                </template>
                <template v-slot:item.isPay="{ item }">
                  <span v-for="(billing, index) in item.billings" v-bind:key="index">
                    <b-badge v-if="billing.payment" class="mr-2" variant="success">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                    <b-badge v-else class="mr-2" variant="danger">
                      {{ billing.patient.name }} {{ billing.patient.lastname }}
                    </b-badge>
                  </span>
                </template>
                <template v-slot:item.canceled="{ item }">
                  <span v-if="!item.deletedAt" class="badge badge-success">{{
                    $t("generic.no")
                  }}</span>
                  <span v-else class="badge badge-danger">{{
                    $t("generic.yes")
                  }}</span>
                </template>
              </v-data-table>
            </div>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { xray } from "../../../config/pluginInit";

import moment from "moment";

import OnlineOrOfflineFilterSelect from "../../../json/filter/OnlineOrOfflineFilterSelect";
import YesOrNoFilterSelect from "../../../json/filter/YesOrNoFilterSelect";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/es";

import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import PaymentPlaceFilterSelect from "../../../json/filter/PaymentPlaceFilterSelect";

import utilsService from "../../../services/utils";
import scheduleService from "../../../services/schedule";
import professionalService from "../../../services/professional";

export default {
  name: "Session",
  mounted() {
    xray.index();
    this.getAllSessions();
    this.getAllProfessionals();
    this.getAllVisitType();
    utilsService.auditActivity({ action: "VIEW", module: "PATIENT_SESSIONS", info: "" });
  },
  watch: {
    pagination: {
      handler() {
        if (this.start) {
          this.getAllSessions();
        }
        this.start = true;
      },
    },
  },
  methods: {
    changeFilter() {
      this.pageSize = 10;
      this.currentPage = 1;
      this.getAllSessions();
    },
    cloneFilterSend() {
      let clone = JSON.parse(JSON.stringify(this.filter));

      //Professionals

      if (clone.professionals) {
        let professionalREST = [];
        clone.professionals.forEach(function (professional) {
          professionalREST.push(professional.value);
        });
        clone.professionals = professionalREST;
      } else {
        clone.professionals = [];
      }

      //Patients

      if (clone.patients) {
        let patientsREST = [];
        clone.patients.forEach(function (patient) {
          patientsREST.push(patient.value);
        });
        clone.patients = patientsREST;
      } else {
        clone.patients = [];
      }

      // StartAt
      if (clone.startTo) {
        clone.startTo = moment(clone.startTo)
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startTo = null;
      }

      if (clone.startFrom) {
        clone.startFrom = moment(clone.startFrom)
          .set("hour", 24)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0);
      } else {
        clone.startFrom = null;
      }

      // Online
      if (clone.online) {
        if (clone.online === "ALL") {
          clone.online = null;
        } else if (clone.online === "ONLINE") {
          clone.online = true;
        } else if (clone.online === "OFFLINE") {
          clone.online = false;
        } else {
          clone.online = null;
        }
      } else {
        clone.online = null;
      }

      // Invoice
      if (clone.invoice) {
        if (clone.invoice === "ALL") {
          clone.invoice = null;
        } else if (clone.invoice === "WITHOUT_INVOICE") {
          clone.invoice = false;
        } else if (clone.invoice === "WITH_INVOICE") {
          clone.invoice = true;
        } else {
          clone.invoice = null;
        }
      } else {
        clone.invoice = null;
      }

      // Paid
      if (clone.paid) {
        if (clone.paid === "ALL") {
          clone.paid = null;
        } else if (clone.paid === "YES") {
          clone.paid = true;
        } else if (clone.paid === "NO") {
          clone.paid = false;
        } else {
          clone.paid = null;
        }
      } else {
        clone.paid = null;
      }

      // Deleted
      if (clone.deleted) {
        if (clone.deleted === "ALL") {
          clone.deleted = null;
        } else if (clone.deleted === "YES") {
          clone.deleted = true;
        } else if (clone.deleted === "NO") {
          clone.deleted = false;
        } else {
          clone.deleted = null;
        }
      } else {
        clone.deleted = null;
      }

      // VisitType
      if (clone.visitTypes && clone.visitTypes.length !== 0) {
        let visitTypeResult = [];
        clone.visitTypes.forEach(function (item) {
          visitTypeResult.push(item.value);
        });

        clone.visitTypes = visitTypeResult;
      } else {
        clone.visitTypes = null;
      }

      return clone;
      //
    },
    async getAllSessions() {
      let self = this;

      let data = this.cloneFilterSend();

      this.$awn.asyncBlock(
        scheduleService.getAllEventsAndDeletePerformance(
          this.pagination.page - 1,
          this.pagination.itemsPerPage,
          data
        ),
        (response) => {
          self.sessions = response.data.content;
          self.total = response.data.pageable.total;
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllEventsAndDeletePerformance",
            module: "view-pages-patient-session",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              page: this.pagination.page - 1,
              itemsPerPage: this.pagination.itemsPerPage,
              data: data
            })
          });
        },
        " "
      );
    },
    async getAllVisitType() {
      let self = this;

      scheduleService
        .getAllVisitTypeActive()
        .then((response) => {
          if (response) {
            self.visitTypeMap = new Map();

            let combo = [];
            response.data.forEach(function (item) {
              self.visitTypeMap.set(item.id, item);
              combo.push({
                colour: item.colour,
                value: item.id,
                text: item.name,
              });
            });
            self.visitTypeSelect = combo;
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "scheduleService.getAllVisitTypeActive",
            module: "view-pages-patient-session",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              userId: localStorage.getItem("userId")
            })
          });
        });
    },
    createOptionPatient(data) {
      let self = this;
      utilsService
        .getFile(data.uuid)
        .then((response) => {
          if (response) {
            data.file = response.data.data;
          }
        })
        .catch(function (error) {
          utilsService.auditErrorFrontent({
            info: "utilsService.getFile",
            module: "view-pages-patient-session",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              uuid: data.uuid
            })
          });
        });
    },
    async getAllProfessionals() {
      let self = this;

      professionalService
        .getAll()
        .then((response) => {
          let combo = [];
          response.data.forEach(function (item) {
            let data = {
              avatar: item.avatarUrl
                ? item.avatarUrl + "/" + localStorage.getItem("authorization")
                : "",
              uuid: item.uuid,
              value: item.id,
              text: item.name + " " + item.lastname,
            };
            combo.push(data);
          });
          self.professionalsFilterSelect = combo;
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "professionalService.getAll",
            module: "view-pages-patient-session",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: null
          });
        }, " ");
    },
  },
  data() {
    return {
      start: false,
      total: 0,
      pagination: {},
      pageSize: 10,
      currentPage: 1,

      sessions: [],
      headers: [
        {
          text: this.$i18n.t("public.views.Pages.Patient.Session.headers.date"),
          align: "start",
          value: "date",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.modality"
          ),
          value: "modality",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.hasInvoice"
          ),
          value: "hasInvoice",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.hasPatients"
          ),
          value: "hasPatients",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.hasProfessionalLead"
          ),
          value: "hasProfessionalLead",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.hasProfessionals"
          ),
          value: "hasProfessionals",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.visitType"
          ),
          value: "visitType",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.isPay"
          ),
          value: "isPay",
        },
        {
          text: this.$i18n.t(
            "public.views.Pages.Patient.Session.headers.canceled"
          ),
          value: "canceled",
        },

        //{ text: "Acciones", value: "id" },
      ],
      sessions: [],
      //Filter
      filter: {
        professionals: [],
        patients: [],
        startTo: null,
        startFrom: null,
        online: null,
        invoice: null,
        paid: null,
        deleted: null,
        visitTypes: null,
      },
      //Select filter
      paidSelect: OnlineOrOfflineFilterSelect,
      yesOrNoSelect: YesOrNoFilterSelect,
      paymentPlace: PaymentPlaceFilterSelect,
      patientsFilterSelect: [],
      professionalsFilterSelect: [],
      visitTypeSelect: [],
      //Config date picker
      //vue2-data-picker
      myFormat: "DD/MM/YYYY",
      momentFormat: {
        //[optional] Date to String
        stringify: (date) => {
          return date ? moment(date).format("LL") : "";
        },
        //[optional]  String to Date
        parse: (value) => {
          return value ? moment(value, "LL").toDate() : null;
        },
        //[optional] getWeekNumber
        getWeek: (date) => {
          // a number
        },
      },
    };
  },
  components: {
    DatePicker,
    multiselect: Multiselect,
  },
};
</script>
